import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";

export const getOrders = createAsyncThunk(
    "orders/getOrders",
    async ({ token, offset = 1, limit = 15 }, { rejectWithValue }) => {
        try {
            const response = await axios.get(
                `${process.env.REACT_APP_BASE_URL}/orders/list`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                    params: {
                        offset: offset,
                        limit: limit
                    }
                }
            );
            if (response.data.status) {
                return { offset, response: response.data.response.items };
            } else {
                return rejectWithValue("Failed to fetch ");
            }
        } catch (error) {
            return rejectWithValue(error.response?.data || "Unknown error");
        }
    }
);

const OrdersSlice = createSlice({
    name: "orders",
    initialState: {
        OrdersData: [],
        isLoading: false,
        isError: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getOrders.pending, (state) => {
                state.isLoading = true;
                state.isError = null;
            })
            .addCase(getOrders.fulfilled, (state, action) => {
                state.isLoading = false;

                if (action.payload.offset === 1) {
                    state.OrdersData = action.payload.response

                } else {
                    state.OrdersData = [...state.OrdersData, ...action.payload.response]

                }
            })
            .addCase(getOrders.rejected, (state, action) => {
                state.isLoading = false;
                toast(action.payload)


            });
    },
});

export default OrdersSlice.reducer;
